// src/theme/components/stat.js
import { statAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(statAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  label: {
    color: "textSecondary",
    fontSize: "xs",
    fontWeight: "medium",
    letterSpacing: "0.01em",
    textTransform: "none",
  },
  number: {
    color: "textPrimary",
    fontSize: "lg",
    fontWeight: "semibold",
    letterSpacing: "-0.01em",
  },
  helpText: {
    color: "textMuted",
    fontSize: "xs",
  },
  icon: {
    color: "iconMuted",
  },
});

const sizes = {
  xs: definePartsStyle({
    label: { fontSize: "xs" },
    number: { fontSize: "sm" },
    helpText: { fontSize: "xs" },
  }),
  sm: definePartsStyle({
    label: { fontSize: "xs" },
    number: { fontSize: "md" },
    helpText: { fontSize: "xs" },
  }),
  md: definePartsStyle({
    label: { fontSize: "sm" },
    number: { fontSize: "lg" },
    helpText: { fontSize: "sm" },
  }),
  lg: definePartsStyle({
    label: { fontSize: "md" },
    number: { fontSize: "xl" },
    helpText: { fontSize: "sm" },
  }),
};

export const statTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: "md",
  },
});

export default statTheme;
